<template>
  <div ref="pdfContainer" class="pdf-viewer">
    <b-card header="Vista Ampliada del Documento">
      <pdf 
        :key="pdfKey"
        ref="pdfRef"
        :src="url"
        :page="page"
        :scale="scale"
        @num-pages="numPages = $event"
        @progress="onProgress"
        @loaded="loading = false"/>
      <!-- <app-viewer
        v-if="rendered"
        :source="base64"
        style="height: 450px; width: 800px;"
        @download="download"
      />       -->

      <div v-if="loading" style="margin-top: 10px;">
        <progress :value="progress" max="100"></progress>
        {{ progress }}%
      </div>

      <div class="nav">
        <b-button size="sm" class="page-link prev-next" 
          @click.prevent="prevPage" :disabled="page <= 1">Prev.</b-button>
        <div v-for="pageNav in pages" :key="pageNav.id">
          <b-button size="sm" 
            :class="{ 'page-link': true, 'active': page == pageNav.value }" 
            @click.prevent="setPage(pageNav.value)">{{ pageNav.value }}</b-button>
        </div>
        <b-button size="sm" class="page-link prev-next" 
          @click.prevent="nextPage" :disabled="page >= numPages">Prox.</b-button>

        <!-- <button @click="prevPage" :disabled="page <= 1">Anterior</button>
        <span>Página {{ page }} de {{ numPages }}</span>
        <button @click="nextPage" :disabled="page >= numPages">Siguiente</button> -->

        <!-- <button @click="scale += 0.2">Zoom +</button>
        <button @click="scale -= 0.2">Zoom -</button> -->
      </div>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="downloadPdf">Descargar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PDF',
  components: {
    pdf
  },
  props: {
    filename: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      pdfKey: 1,
      page: 1,
      numPages: 0,
      scale: 0.6,
      progress: 0,
      loading: true,
    }
  },
  created() {
  },
  mounted() {
    // ajustar también al redimensionar
    window.addEventListener('resize', this.onPdfLoaded);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onPdfLoaded);
  },
  computed: {
    pages() {
      if (this.numPages == 0) {
          return [];
      }
      if (this.numPages < 5) {
        let numbers = [];
        for (let index = 1; index <= this.numPages; index++) {
          numbers.push({ id: index, value: index});
        }
        return numbers;
      }

      return [
        { id: 1, value: 1},
        { id: 2, value: 2},
        { id: 3, value: 3},
        { id: 4, value: 4},
        { id: 5, value: 5}
      ]
    }
  },
  methods: {
    onPdfLoaded() {
      this.$nextTick(() => {
        const container = this.$refs.pdfContainer;
        if (container) {
          const availableWidth = container.offsetWidth;
          const pdfOriginalWidth = 612; // tamaño A4 en puntos (8.5 pulgadas * 72dpi)
          this.scale = availableWidth / pdfOriginalWidth;
        }
      });
    },
    nextPage() {
      if (this.page < this.numPages) this.page++;
    },
    prevPage() {
      if (this.page > 1) this.page--;
    },
    setPage(page) {
      this.page = page;
    },
    onProgress(event) {
      const loaded = event.loaded || 0;
      const total = event.total || 1;
      this.progress = Math.round((loaded / total) * 100);
    },
    async downloadPdf() {
      try {
        const response = await fetch(this.url);
        const blob = await response.blob();
        saveAs(blob, this.filename);
      } catch (err) {
        alert('Error al descargar el PDF');
        console.error(err);
      }
    },    
    close() {
      this.$emit('close')
    },
  },
  watch: {
    scale() {
      this.pdfKey++;
    }
  }
}
</script>

<style>
  .pdf-viewer .page-link {
    border-radius: 0 !important; 
    padding: 4px 8px !important;
    font-size: 0.76563rem !important;
    line-height: 1.5 !important;
  }
  .pdf-viewer .page-link.disabled {
    color: #73818f;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #c8ced3;
  }
  .pdf-viewer .page-link.active {
    z-index: 1;
    color: #fff !important;
    background-color: #20a8d8 !important;
    border-color: #20a8d8 !important;
  }  
  .pdf-viewer .page-link:focus {
    z-index: 2;
    outline: 0 !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25) !important;
    box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25) !important;
  }  
</style>
